var fs = require('graceful-fs')
var path = require('path')
var jsonFile = require('jsonfile')
var mkdir = require('../mkdirs')

function outputJsonSync (file, data, options) {
  var dir = path.dirname(file)

  if (!fs.existsSync(dir)) {
    mkdir.mkdirsSync(dir)
  }

  jsonFile.writeFileSync(file, data, options)
}

module.exports = outputJsonSync



//////////////////
// WEBPACK FOOTER
// ./~/github-download/~/fs-extra/lib/json/output-json-sync.js
// module id = 353
// module chunks = 0